module.exports = __webpack_public_path__ + "img/Retail6.54bea768.png";